"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LightTheme = exports.DarkTheme = exports.DarkThemeConfig = exports.LightThemeConfig = exports.Themes = exports.CustomisationDataStruct = exports.ThemeConfigStruct = exports.KioskCustomisationStruct = void 0;
const superstruct_1 = require("superstruct");
exports.KioskCustomisationStruct = (0, superstruct_1.type)({
    layout: (0, superstruct_1.optional)((0, superstruct_1.enums)(['standard', 'extended'])),
    backgroundColor: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    buttonColor: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    welcomeText: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    instructionsText: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
/**
 * Per-theme color configuration introduced in v2 of the appearance system.
 * primaryColor replaces buttonColor; secondaryColor replaces headerColor.
 */
exports.ThemeConfigStruct = (0, superstruct_1.type)({
    primaryColor: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    secondaryColor: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    backgroundColor: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    textColor: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
exports.CustomisationDataStruct = (0, superstruct_1.type)({
    // ── v2 fields ──────────────────────────────────────────────────────────────
    // Per-theme color configurations. When present these take precedence over
    // the legacy flat fields below.
    light: (0, superstruct_1.optional)(exports.ThemeConfigStruct),
    dark: (0, superstruct_1.optional)(exports.ThemeConfigStruct),
    // Active theme selector (shared between v1 and v2)
    theme: (0, superstruct_1.optional)((0, superstruct_1.enums)(['light', 'dark'])),
    // ── Legacy v1 fields (kept for backwards compatibility) ────────────────────
    // Old places store colors as flat fields on customisation directly.
    // New code writes to light/dark sub-objects instead; these are only read
    // for migration purposes in CssCustomisation and BrandCustomisationPage.
    buttonColor: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    headerColor: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    backgroundColor: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    textColor: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    // Non-color fields (unchanged)
    favIcon: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    bookingBaseUrl: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    kiosk: (0, superstruct_1.optional)(exports.KioskCustomisationStruct),
});
exports.Themes = (0, superstruct_1.enums)(['light', 'dark']);
// ── v2 per-theme defaults ────────────────────────────────────────────────────
exports.LightThemeConfig = {
    primaryColor: '#7669ff',
    secondaryColor: '#e8e6ff',
    backgroundColor: '#fff',
    textColor: '#2C353F',
};
exports.DarkThemeConfig = {
    primaryColor: '#7669ff',
    secondaryColor: '#7669ff',
    backgroundColor: '#2C353F',
    textColor: '#fff',
};
// ── Legacy v1 defaults (still used as PlaceStruct defaulted() fallback) ──────
// Do not remove — place.ts depends on LightTheme as the Superstruct default.
exports.DarkTheme = {
    buttonColor: '#7669ff',
    headerColor: '#7669ff',
    backgroundColor: '#2C353F',
    textColor: '#fff',
    theme: 'dark',
};
exports.LightTheme = {
    buttonColor: '#7669ff',
    headerColor: '#e8e6ff',
    backgroundColor: '#fff',
    textColor: '#2C353F',
    theme: 'light',
};
//# sourceMappingURL=customisation.js.map